import { fetchToken, getCredentials, userLogin } from "../Features/Shared/Login/LoginSlice";
import Logo from '../assets/HNELogo.png';
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, FormGroup, Input, InputGroup, Label, Row } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../hooks";
import Loading from "../Components/Loading";

type HasFocus = {
    focus: () => void;
}

type Ref = HTMLInputElement | HTMLTextAreaElement & HasFocus;

const Login = () => {
    const [secureEntry, setSecureEntry] = useState<boolean>(true);
    const [icon, setIcon] = useState<string>('fa fa-lg fa-eye-slash')
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [rememberMe, setRememberMe] = useState<boolean>(false);
    const usernameRef = useRef(null);
    const passwordRef = useRef<Ref>(null);
    const dispatch = useAppDispatch();
    const loading = useAppSelector((state) => state.auth.loading);
    const error = useAppSelector((state) => state.auth.error);
    
    useEffect(() => {
        dispatch(fetchToken());
        loadCredentials();
    }, []);

    const loadCredentials = async () => {
        const creds = await getCredentials();
        if (creds) {
            setUsername(creds.username);
            setPassword(creds.password);
            setRememberMe(true);
        }
    };

    const handlePress = () => {
        if (secureEntry === true) {
            setSecureEntry(false)
            setIcon('fa fa-lg fa-eye')
        } else {
            setSecureEntry(true)
            setIcon('fa fa-lg fa-eye-slash')
        }
    };

    const handleLogin = async () => {
        dispatch(userLogin({ username, password, rememberMe }));
    };

    if (loading) {
        return (
            <Loading />
        )
    };

    return (
        <Container>
            <Row>
                <Col>
                    <img src={Logo} style={{ width: '200px'}}/>
                </Col>
            </Row>
            <Row className="justify-content-center py-2">
                <Col lg={6} md={6} sm={8} xs={8}>
                    <Input
                        ref={usernameRef}
                        value={username}
                        type="email"
                        placeholder="Username"
                        onChange={(t) => setUsername(t.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                passwordRef.current?.focus();
                            };
                        }}
                    />
                </Col>
            </Row>
            <Row className="justify-content-center py-2">
                <Col lg={6} md={6} sm={8} xs={8}>
                    <InputGroup>
                        <Input
                            innerRef={passwordRef}
                            value={password}
                            type={secureEntry ? 'password' : 'text'}
                            placeholder="Password"
                            onChangeText={setPassword}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleLogin();
                                }
                            }}
                        />
                        <Button color="primary" onClick={handlePress}>                
                            <i
                                className={icon}
                            />
                        </Button>
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="rememberMe"
                        type="checkbox"
                        className="mx-2 color-primary"
                        color="primary"
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                    />
                    <Label 
                        check
                        for="rememberMe"
                    >
                        Remember Me
                    </Label>
                </Col>
            </Row>
            <Row className="justify-content-center py-2">
                <Col>
                    <Button
                        type="submit"
                        color="primary w-25 fw-bold"
                        className="mainButton"
                        onClick={handleLogin}
                    >
                        Login
                    </Button>
                </Col>
            </Row>
            <Row>
                {error && <p style={{ color: 'red' }}>Error: {error}</p>}
            </Row>
        </Container>
    );
};

export default Login;